export default __webpack_public_path__ + "static/media/illustration-mian-w@2x.4f5929aa.png";